module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Play-ad0db92447452c8b74b490c626aef877.svg";